import { render, staticRenderFns } from "./register-modal.vue?vue&type=template&id=2a4015ef&scoped=true&"
import script from "./register-modal.vue?vue&type=script&lang=js&"
export * from "./register-modal.vue?vue&type=script&lang=js&"
import style0 from "./register-modal.vue?vue&type=style&index=0&id=2a4015ef&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a4015ef",
  null
  
)

export default component.exports